import client from './client';

export const authApi = {
  login: (email, password) =>
    client.post('/auth/login', { email, password }, { auth: false }),

  me: () => client.get('/auth/me'),
};
